import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../components/Sidebar/SideBar4';
import { Card } from 'antd';
import useFetchCauses from '../hooks/fetchCauses';
import { Form, Input, Row, Col,Select,DatePicker,Button,Pagination } from 'antd';
import {app} from '../config';
import {CSVLink} from 'react-csv';
import useFetchOrganizations from '../hooks/fetchOrganizations';
import { dateConverter } from '../utils/utcDateConversion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import getCauseByOrg from '../hooks/getCauseByOrg';
import NewSideBar from '../components/Sidebar/NewSideBar';
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
// import logo from "../../public/logo.png";

// import { faFileExcel } from '@fortawesome/free-solid-svg-icons'

const Orgeventsreport = () => {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  const [reportObj, setReportObj] = useState({});
  const [renderList,setRenderList] = useState([]);
  const [datatoExport,setDataToExport] = useState([]);
  const [respList,setRespList] = useState([]);
  const [entriesCount,setEntriesCount] = useState(0);
  const [current,setCurrent] = useState(1);
  const [newObj,setNewObj] = useState([]);

  const user = JSON.parse(localStorage.getItem('user'));
  const c=getCauseByOrg(user.organizationId);
  const causes=c.response?c.response.data:[];
  const o = useFetchOrganizations();
  const orgs = o.response ? o.response.data : [];
  console.log(orgs);
  const token=getTokenfromUserObj()
  const fetchData=async (obj)=>{
    console.log("fetchData")
    const limit=1000;
    const offset=0;
    obj.limit=limit;
    obj.offset=offset;
    obj.organization=user.organizationId;
    console.log(obj);
    const tr=await axios.post(`${app.URL}/orgreport/events`,obj,{headers:{auth:token}});
    console.log(tr);
    tr.data?setCurrent(1):0;
    let convertedData= tr.data?dateConverter(tr.data.data,'startDate'):console.log("done");
    convertedData=tr.data?dateConverter(convertedData,'endDate'):console.log("done");
    tr.data?setRespList(convertedData):console.log(0);
   
    tr.data?setRenderList(convertedData.slice(0,10))||setEntriesCount(tr.data.data.length):[]
  }
  let newStartDate;
  let newEndDate;
  const onFinish = (values) => {
    console.log('Success:', values);
    if(values.startDate&&values.endDate){
        newStartDate=(values.startDate._d).toUTCString()  ;
        newEndDate=(values.endDate._d).toUTCString();
        newStartDate=new Date(newStartDate).toISOString().slice(0, 19).replace('T', ' ');
        newEndDate=new Date(newEndDate).toISOString().slice(0, 19).replace('T', ' ');
    }
    setReportObj({
      causeId: values.causeId ? values.causeId :null,
      startDate:values.startDate ? newStartDate :null,
      endDate:values.endDate? newEndDate :null,
    });



  };
  console.log(reportObj);
 
  



  useEffect(()=>{
    if(Object.keys(reportObj).length>0)fetchData(reportObj);
  },[reportObj]);
  
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  useEffect(() => {
    const transList=async()=>{
      const user = JSON.parse(localStorage.getItem('user'));
      // if (user.userType === 'A') setEditBtn('block');
      const limit=1000;
      const offset=0;
      const organization=user.organizationId;
      const tranResp=await axios.post(`${app.URL}/orgreport/events`,{limit,offset,organization},{headers:{auth:token}});
      console.log("🚀 ~ file: Users.js:31 ~ userList ~ userResp", tranResp.data)
      let convertedData= tranResp.data?dateConverter(tranResp.data.data,'startDate'):console.log("done");
      convertedData=tranResp.data?dateConverter(convertedData,'endDate'):console.log("done");
      tranResp.data?setRespList(convertedData):console.log(0);
      tranResp.data?setRenderList((convertedData).slice(0,10))||setEntriesCount(tranResp.data.data.length)||setDataToExport(tranResp.data.data):[];

    }
    transList();
    }, []);
    console.log(entriesCount);
    const onChange = async(page) => {
      console.log(page);
      setCurrent(page);
      let limit=10;
      let reqObj={
        limit,
        offset:(page-1)*limit,
      }
      const newRender=respList.slice((page-1)*limit,page*limit);
      console.log(newRender);
      setRenderList(newRender);
    };
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log(timeZone);
    console.log(renderList);
  return (
    <div class='container'>
    <div class='row mt-5'>
      <Form
        name='basic'
        className='ml-5'
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 8,
        }}
        style={{ alignItems: 'flexEnd' }}
        // style={{
        //   maxWidth: 600,
        // }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
        <Row gutter={[16, 16]}>
         
          <Col style={{paddingLeft:"0px",paddingRight:"0px"}} span={4}>
          <Form.Item
            colon={false}
            style={{
              width: 550,
            }}
            name='startDate'
            rules={[
              {
                required: false,
                message: 'Please select date!',
              },
            ]}
          >
            <DatePicker />
          </Form.Item>
          </Col>
          <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={4}>
          <Form.Item
            colon={false}
            name='endDate'
            style={{
              width: 550,
            }}
            rules={[
              {
                required: false,
                message: 'Please select date!',
              },
            ]}
          >
            <DatePicker />
          </Form.Item>
          </Col>
        
          <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={3}>
          <Form.Item
           colon={false}
           
          >
           <button type='primary' class='btn btn-primary button' htmlType='submit'>Search</button>
          </Form.Item>
          </Col>
          <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={3}>
          <CSVLink  icon={faFileExcel} filename={"donation-report.csv"} data={respList}><img style={{marginTop:"-5px"}} src="/excel.png"/></CSVLink>
          {/* <Button><CSVLink  filename={"donation-report.csv"} data={respList}>Export</CSVLink></Button>  */}
          </Col>
        </Row>
        {/* <div class="col-lg-3">
   
   <Form.Item  
            label='Cause Name'
            name='causeName'
            rules={[
              {
                required: false,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>

    </div>
    <div class="col-lg-3">
    <Form.Item  
            label='Cause Name'
            name='causeName'
            rules={[
              {
                required: false,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>
    </div>
    <div class="col-lg-4">
    <Form.Item  
            label='Cause Name'
            name='causeName'
            rules={[
              {
                required: false,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>
    </div>  */}
      </Form>
      <div class='row'>
  <div class="col-lg-11 ">
      <div class="table-responsive styled-table ">
      {/* <h1 style={{display:tableShow?"none":"block"}}>{err}</h1> */}
      {/* style={{display:tableShow?"block":"none"}} */}
          <table class="table" >
              <thead class="thead-light">
                  <tr>
                  <th>{t("Event Name")}</th>
                      <th>{t("Start Date")}</th>
                      <th>{t("End Date")}</th>
                      <th>{t("Speaker")}</th>
                      <th>{t("Status")}</th>
                      <th> </th>
                  </tr>
              </thead>
              <tbody>
               {renderList?renderList.map((output)=>
                  <tr>
                    <td>{output.eventName}</td>
                      <td>{output.startDate}</td>
                      <td>{output.endDate}</td>
                      <td>{output.speaker}</td>
                      <td>{output.status}</td>
                      {/* <td><button type="button" class="btn btn-primary color1 button" onClick={() => editUser(output)}>{t("Edit")}</button></td> */}
                      <td></td>
                  </tr>,
                 ):" "}
              </tbody>
          </table>
      </div>
  </div>
  </div>
  <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} current={current} total={entriesCount} />
    </div>

    {/* <div class='row'>
      <div class='col mt-3'>
        <div class='input-group ml-60' style={{ width: '40%' }}>
          <input type='search' class='form-control rounded w-50' placeholder='Search' aria-label='Search' aria-describedby='search-addon' />
          <button type='button' class='btn btn-outline-primary color1 button text-white'>
            search
          </button>
        </div>
      </div>
    </div> */}
    {/* <div class='row'>
      <div class="col-lg-6 fs-3 fw-bold"> <div class="mt-3"> {t('Causes')} </div></div>
      <div class="col-lg-5 mt-3 text-right"><button class="btn btn-primary button">Add Cause</button></div>
      </div> */}
    {/* <div class="row">
    {causes?causes.map((cause)=>{
      return(

        <div key={cause.causeId} class='col-lg-4 text-black mt-3 mb-3 '>
        <Card
          title={cause.cause}
          bordered={false}
          style={{
            width: 250,
            maxHeight:300,
          }}
          class="tbl mt-3"
        >
          <p>{cause.description.slice(0,90)}</p>
          <button class="btn btn-primary button mt-3" onClick={() => editCause(cause)}>Edit</button>
        </Card>
        </div>
      )
         
    }):""}
 
      
 </div> */}
  </div>
  );
};

export default Orgeventsreport;
